import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Campaing } from '../models/campaing';

@Injectable()
export class CampaingService {
   public url: string;
   constructor(
       private _http: HttpClient
   ) {
       this.url = 'http://130.211.195.253/ipdialbox/api_campaing.php?';
   }
   seleccionar(codigo:number) {
    return this._http.get(`${this.url}seleccionar.php?codigo=${codigo}`);
  }

  createcampaing(token, action, typecampaing, campaing, name, id, opt1, opt2, tel01): Observable<any> {
    const headers = new HttpHeaders().set('content-Type', 'application/json');
    return this._http.post(`${this.url}token=${token}&action=${action}&type_campaing=${typecampaing}&campaing=${campaing}&name=${name}&id=${id}&opt1=${opt1}&opt2=${opt2}&tel01=9${tel01}`, { headers: headers });
   }

   /* 130.211.195.253/ipdialbox/api_campaing.php?token=7b69645f6469737472697d2d3230323031303039313032343235&action=insert
   &type_campaing=predictive&campaing=5765&name={$cust_name}&id={$cust_phone}&opt1={$cust_email}&opt2={$quoted_message}&tel01=9{$cust_phone} */
   createcampain(token, action, typecampaing, campaing, name, id, opt1, opt2, tel01): Observable<any> {
    const headers = new HttpHeaders().set('content-Type', 'application/json');
    return this._http.post(this.url + 'token=' + token + '&action=' + action + '&type_campaing=' + typecampaing + '&campaing=' + campaing + '&name=' + name + 
    '&id=' + id + '&opt1=' + opt1 + '&opt2=' + opt2 + '&tel01=9' + tel01, { headers: headers });
   }
}
